/* =============================================================================
 * [OS-LEGADO-CONGELADO] ARQUIVO TEMPORARIO - APAGAR APOS VALIDACAO
 * =============================================================================
 * Copia CONGELADA do modulo antigo de "OS para coleta" (versao que estava em
 * producao antes da entrada do modulo novo).
 *
 * Origem desta copia: src/Components/talhasvg/index.tsx
 * Papel: componente compartilhado congelado
 *
 * POR QUE ISSO EXISTE
 *   O modulo novo de OS substituiu o antigo. Esta copia fica disponivel por
 *   ~1 SEMANA como plano de contingencia: se o modulo novo apresentar
 *   problema, o time volta a usar esta versao sem interromper o trabalho.
 *
 * NAO EDITE ESTE ARQUIVO
 *   Ele e um retrato fiel do comportamento antigo. Qualquer correcao deve ser
 *   feita no modulo NOVO. Editar aqui destroi o valor da copia.
 *
 * COMO APAGAR (quando o modulo novo for validado)
 *   1. Remover a pasta inteira: src/Views/app/precisao/OSAntigaLegado/
 *   2. Remover a rota/menu marcado com [OS-LEGADO-CONGELADO] em
 *      src/Configs/Navegacao.ts
 *   3. Conferir que nao sobrou nenhuma referencia:
 *        grep -rn "OSAntigaLegado\|OS-LEGADO-CONGELADO" src/
 *   Nada fora desta pasta depende dela, entao a remocao e segura.
 * ========================================================================== */

/* eslint-disable react/require-default-props */
import React from 'react'

import geojson2svg from 'geojson-to-svg'

interface TypesCordenates {
  coordinates: [string | number, string | number]
  fill: string
  fillOpacity?: number
  multi?: boolean,
  className?: string;
}

const Svg: React.FC<TypesCordenates> = (props) => {
  const { coordinates, fill = 'green', multi = false, fillOpacity = 1, className } = props
  let pontos = []
  let features = []

  if (coordinates === undefined) {
    features = [
      {
        type: 'Feature',
        geometry: {
          type: 'LineString',
          coordinates: [0, 0],
        },
        properties: {
          thumb: 'basic',
        },
      },
    ]
  }

  if (multi) {
    coordinates?.forEach((talhao) => {
      // @ts-ignore
      talhao.filter((e) => (e.latitude || e.lat) && (e.longitude || e.lng)).forEach((dados) => {
        // @ts-ignore
        const latitude = dados.longitude || dados.lng
        // @ts-ignore
        pontos = [
          ...pontos,
          [
            // @ts-ignore
            dados.longitude || String(dados.lng),
            latitude
            // parseFloat(String(latitude).replace('-', '')),
          ],
        ]

        return pontos
      })
    })

    features = [
      ...features,
      {
        type: 'Feature',
        geometry: {
          type: 'MultiPolygon',
          coordinates: [pontos],
        },
        properties: {
          thumb: 'basic',
        },
      },
    ]
  } else {
    coordinates?.filter((e: any) => (e.latitude || e.lat) && (e.longitude || e.lng)).forEach((dados) => {
      // @ts-ignore
      const latitude = dados.latitude || dados.lat
      // @ts-ignore
      pontos = [
        [
          // @ts-ignore
          dados.longitude || String(dados.lng),
          -latitude
          // parseFloat(String(latitude).replace('-', '')),
        ],
        ...pontos,
      ]

      return pontos
    })

    features = [
      {
        type: 'Feature',
        geometry: {
          type: 'Polygon',
          coordinates: [pontos],
        },
        properties: {
          thumb: 'basic',
        },
      },
    ]
  }

  let svg
  if (pontos.length === 0) {
    svg = null
  } else {
    svg = geojson2svg()
      .type('thumb')
      .styles({
        basic: { fill, fillOpacity, strokeColor: '#ffffff' },
      })
      .data({
        type: 'FeatureCollection',
        features,
      })
      .render() 
  }
  
  
  return (
    <svg
      style={{ maxWidth: '50px', maxHeight: '50px', marginRight: 0 }}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: svg }}
      className={className??""}
    />
  )
}

export default Svg